import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_GARAGES_DATA, FETCH_GARAGES_EDIT_DATA } from "./actionTypes";
import {
  fetchGaragesSuccess,
  fetchGaragesFailure,
  fetchGaragesEditSuccess,
  fetchGaragesEditFailure,
} from "./actions";

function* fetchGaragesDataSaga() {
  try {
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + "/api/web/garages",{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchGaragesSuccess(response.data));
  } catch (error) {
    yield put(fetchGaragesFailure(error.message));
  }
}

function* fetchGaragesEditDataSaga(action) {
  try {
    const id = action.payload;
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + `/api/web/garages/${id}`,{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchGaragesEditSuccess(response.data));
  } catch (error) {
    yield put(fetchGaragesEditFailure(error.message));
  }
}

export default function* garagesSaga() {
  yield takeEvery(FETCH_GARAGES_DATA, fetchGaragesDataSaga);
  yield takeEvery(FETCH_GARAGES_EDIT_DATA, fetchGaragesEditDataSaga);
}
